export default {
  filters: {
    dateRange: {
      start: null,
      end: null,
    },
    filterVideos: {
      selectedVideos: null,
    },
    compareVideos: {
      selectedVideos: null,
    },
  },
  disabledDateRange: false,
  errorState: false,
}
